/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { EventTypeDto } from '../models/EventTypeDto';
import type { GetEventDto } from '../models/GetEventDto';
import type { GetNewEventDto } from '../models/GetNewEventDto';
import type { OfferDto } from '../models/OfferDto';
import type { SaveSaleOfferInput } from '../models/SaveSaleOfferInput';
import type { VideoEventPatchInput } from '../models/VideoEventPatchInput';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class EventService {

  /**
   * @returns GetEventDto Success
   * @throws ApiError
   */
  public static getEventGetEvent(): CancelablePromise<GetEventDto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/Event/GetEvent',
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param id 
   * @returns GetNewEventDto Success
   * @throws ApiError
   */
  public static getEventGetEvent1(
id?: number,
): CancelablePromise<GetNewEventDto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/event/get-event',
      query: {
        'id': id,
      },
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @returns GetNewEventDto Success
   * @throws ApiError
   */
  public static getEventGetEvents(): CancelablePromise<Array<GetNewEventDto>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/event/get-events',
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param id 
   * @returns GetEventDto Success
   * @throws ApiError
   */
  public static getEventGetEventPreview(
id?: number,
): CancelablePromise<GetEventDto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/Event/GetEventPreview',
      query: {
        'id': id,
      },
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param code 
   * @param videoId 
   * @returns OfferDto Success
   * @throws ApiError
   */
  public static getEventGetVideoEvent(
code?: string,
videoId?: number,
): CancelablePromise<OfferDto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/Event/GetVideoEvent',
      query: {
        'code': code,
        'videoId': videoId,
      },
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param requestBody 
   * @returns any Success
   * @throws ApiError
   */
  public static postEventSaveSaleOfferEvent(
requestBody?: SaveSaleOfferInput,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/Event/SaveSaleOfferEvent',
      body: requestBody,
      mediaType: 'application/json-patch+json',
    });
  }

  /**
   * @param id 
   * @param requestBody 
   * @returns any Success
   * @throws ApiError
   */
  public static patchEventVideoEvent(
id: number,
requestBody?: VideoEventPatchInput,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/Event/VideoEvent/{id}',
      path: {
        'id': id,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
    });
  }

  /**
   * @param code 
   * @returns EventTypeDto Success
   * @throws ApiError
   */
  public static getEventGetEventTypesByGroupCode(
code?: string,
): CancelablePromise<Array<EventTypeDto>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/Event/GetEventTypesByGroupCode',
      query: {
        'code': code,
      },
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

}
